<ng-container *ngIf="commissionLevel === CommissionLevel.SuperCentre">
  <div class="heading-1 break-word">{{ 'general.api_menu_commission_fees' | translate }}</div>

  <mat-tab-group mat-align-tabs="left" animationDuration="0ms">
    <mat-tab [label]="'general.api_commission_fees_general_info' | translate">
      <ng-container *ngTemplateOutlet="general"></ng-container>
    </mat-tab>
    <mat-tab [label]="'general.api_commission_fees_audit_logs' | translate" *ngIf="canSeeAuditLogs">
      <mat-card appearance="outlined">
        <audit-log-table [pageData]="auditLogPage" [(page)]="auditPageNumber" (pageChange)="getAuditLogs()"></audit-log-table>
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</ng-container>

<ng-container *ngIf="commissionLevel !== CommissionLevel.SuperCentre">
  <ng-container *ngTemplateOutlet="general"></ng-container>
</ng-container>

<ng-template #general>
  <div class="flex flex-column" *ngIf="commissionLevel !== CommissionLevel.Event">
    <mat-card appearance="outlined" *ngIf="commissionLevel !== CommissionLevel.SuperCentre && !anyFeeMissing && paymentTerm" class="flex flex-column no-margin">
      <app-section-header [title]="'general.api_fees_payment_term'" [tooltip]="'general.api_fees_payment_term_tooltip'" [useInternalDesign]="true"></app-section-header>
      <ng-container *ngIf="paymentTerm" [ngTemplateOutlet]="paymentTermTemplate"></ng-container>
    </mat-card>
    <app-info-message *ngIf="commissionLevel === CommissionLevel.SuperCentre" [color]="'text-base'" [message]="'general.api_fees_netting'"
                      [tooltip]="'general.api_fees_netting_tooltip'" [noIcon]="true"></app-info-message>
    <app-info-message *ngIf="commissionLevel === CommissionLevel.SuperCentre && anyFeeMissing" [warning]="true" [message]="'general.api_fees_commission_not_all_created'"></app-info-message>
    <app-info-message *ngIf="commissionLevel !== CommissionLevel.SuperCentre && anyFeeMissing" [message]="'general.api_fees_commission_not_all_created'"></app-info-message>
    <div class="card-grid grid-2 grid-column-mobile" *ngIf="commissionLevel === CommissionLevel.SuperCentre || !anyFeeMissing">
      <mat-card appearance="outlined" class="commission-fee-card no-margin" *ngFor="let commissionFee of commissionFees">
        <div class="flex space-between">
          <div class="heading-5">{{ ('general.api_fees_' + (commissionFee.type | lowercase)) | translate }}</div>
          <div *ngIf="commissionFee.id && canManageFees">
            <button mat-button class="input-button icon-button" (click)="openCommissionFeeModal(commissionFee)">
              <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
            </button>
          </div>
        </div>
        <app-link *ngIf="!commissionFee.id" class="card-center-link" [linkClass]="'margin-auto'"
                  [link]="'general.api_fees_' + (commissionFee.type | lowercase) + '_add'" [icon]="'plus'"
                  (linkClicked)="openCommissionFeeModal(commissionFee)"></app-link>
        <ng-container *ngIf="commissionFee.id">
          <div class="flex flex-column">
            <ng-container *ngIf="authService.user.isSuperCentre">
              <app-label-value [label]="'general.api_fees_comment'" [value]="commissionFee.comment"></app-label-value>
              <hr class="slim">
            </ng-container>
            <app-label-value [label]="'general.api_fees_current_fee_price'"
                             [value]="commissionFee.currentPeriodPrice?.feePrice ? (commissionFee.currentPeriodPrice?.feePrice | price) : (commissionFee.currentPeriodPrice?.feePercent ? (commissionFee.currentPeriodPrice?.feePercent + '%') : null)"></app-label-value>
            <app-label-value [label]="'general.api_fees_current_period'"
                             [value]="commissionFee.currentPeriodPrice?.period?.start ? (commissionFee.currentPeriodPrice?.period | period: {hasTimeInPeriod: true, threeDotsIfEmpty: true}) : null"></app-label-value>
            <app-label-value *ngIf="commissionLevel !== CommissionLevel.SuperCentre" [label]="'general.api_fees_current_fee_level'"
                             [value]="commissionFee.currentPeriodPrice?.level ? ('general.api_fees_commission_level_' + (commissionFee.currentPeriodPrice?.level | lowercase)) : null"></app-label-value>
            <mat-tab-group mat-align-tabs="left" class="tabs max-width top-spacer">
              <mat-tab [label]="'general.api_fees_tab_future' | translate">
                <ng-container [ngTemplateOutlet]="feePeriodPriceList"
                              [ngTemplateOutletContext]="{periodPrices: commissionFee.futurePeriodPrices, commissionFee: commissionFee}"></ng-container>
              </mat-tab>
              <mat-tab [label]="'general.api_fees_tab_history' | translate">
                <ng-container [ngTemplateOutlet]="feePeriodPriceList"
                              [ngTemplateOutletContext]="{periodPrices: commissionFee.pastPeriodPrices, commissionFee: commissionFee}"></ng-container>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ng-container>
      </mat-card>
    </div>
  </div>
</ng-template>

<ng-template #feePeriodPriceList let-periodPrices="periodPrices" let-commissionFee="commissionFee">
  <div class="body-3 text-muted" *ngIf="!periodPrices?.length">
    <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
    {{ 'general.api_fees_no_records' | translate }}
  </div>
  <table class="report-table" *ngIf="periodPrices?.length">
    <thead>
    <tr>
      <th class="min-width white-space-no-wrap">{{ 'general.api_fees_price' | translate }}</th>
      <th>{{ 'general.api_fees_period' | translate }}</th>
      <th *ngIf="commissionLevel !== CommissionLevel.SuperCentre">{{ 'general.api_fees_level' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let feePeriodPrice of periodPrices; let feeIndex = index">
      <tr *ngIf="feeIndex < 3 || commissionFee.showMore">
        <td>{{ feePeriodPrice.feePrice !== null ? (feePeriodPrice.feePrice | price) : (feePeriodPrice.feePercent + '%') }}</td>
        <td>{{ feePeriodPrice.period | period: {hasTimeInPeriod: true, threeDotsIfEmpty: true} }}</td>
        <td class="break-word" *ngIf="commissionLevel !== CommissionLevel.SuperCentre">
          {{ ('general.api_fees_commission_level_' + (feePeriodPrice.level | lowercase)) | translate }}
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
  <app-link *ngIf="periodPrices.length > 3" [linkClass]="'margin-auto top-spacer'"
            [link]="commissionFee.showMore ? 'general.api_show_less' : 'general.api_show_more'" (linkClicked)="commissionFee.showMore = !commissionFee.showMore"></app-link>
</ng-template>

<!-- EVENT VIEW -->
<ng-container *ngIf="commissionLevel === CommissionLevel.Event">
  <div class="flex flex-column" *ngIf="utilService.isMobile">
    <app-info-message *ngIf="anyFeeMissing" [message]="'general.api_fees_commission_not_all_created'"></app-info-message>
    <ng-container *ngIf="!anyFeeMissing">
      <app-label-value *ngIf="paymentTerm" [label]="'general.api_fees_payment_term'" [tooltip]="'general.api_fees_payment_term_tooltip'"
                       [template]="paymentTermTemplate" [withMargin]="true"></app-label-value>
      <mat-slide-toggle [(ngModel)]="displayPastFees" [ngModelOptions]="{standalone: true}">
        {{ 'general.api_fees_display_past_fees' | translate }}
      </mat-slide-toggle>
      <div class="flex flex-column decreased-margin" *ngFor="let commissionFee of commissionFees">
        <div class="flex space-between fee-type-header">
          <div class="bold">{{ ('general.api_fees_' + (commissionFee.type | lowercase)) | translate }}</div>
          <app-link *ngIf="canManageFees" [link]="'general.api_fees_commission_edit'" [icon]="'pencil'" (linkClicked)="openCommissionFeeModal(commissionFee)"></app-link>
        </div>
        <div>
          <!-- MOBILE PAST FEES -->
          <ng-container *ngIf="displayPastFees">
            <div class="listing-block" *ngFor="let pastPeriodPrice of commissionFee.pastPeriodPrices; let feeIndex = index;">
              <table class="max-width bottom-spacer text-muted">
                <tbody>
                  <tr>
                    <td colspan="2">
                      <div class="bottom-spacer-half">
                        <div class="no-margin heading-5 bold text-muted">
                          <span class="medium">{{ 'general.api_fees_price' | translate }}</span>
                          {{ pastPeriodPrice.feePrice !== null ? (pastPeriodPrice.feePrice | price) : (pastPeriodPrice.feePercent + '%') }}</div>
                        <span class="text-muted body-3">{{ ( 'general.api_fees_commission_level_' + (pastPeriodPrice.level | lowercase)) | translate }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="medium">{{ 'general.api_fees_status' | translate }}</td>
                    <td class="align-right">{{ 'general.api_fees_status_past' | translate }}</td>
                  </tr>
                  <tr>
                    <td class="medium">{{ 'general.api_fees_period_start' | translate }}</td>
                    <td class="align-right">{{ pastPeriodPrice.period.start | moment: { withTime: true } }}</td>
                  </tr>
                  <tr>
                    <td class="medium">{{ 'general.api_fees_period_end' | translate }}</td>
                    <td class="align-right">{{ pastPeriodPrice.period.end ? (pastPeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
                  </tr>
                </tbody>
              </table>
              <hr class="max-width no-margin">
            </div>
          </ng-container>
          <!-- MOBILE CURRENT FEES -->
          <div class="listing-block" *ngIf="commissionFee.currentPeriodPrice">
            <table class="max-width bottom-spacer">
              <tbody>
                <tr>
                  <td colspan="2">
                    <div class="bottom-spacer-half">
                      <div class="no-margin heading-5 bold">
                        <span class="medium">{{ 'general.api_fees_price' | translate }}</span>
                        {{ commissionFee.currentPeriodPrice.feePrice !== null ? (commissionFee.currentPeriodPrice.feePrice | price) : (commissionFee.currentPeriodPrice.feePercent + '%') }}
                      </div>
                      <span class="text-muted body-3">{{ ( 'general.api_fees_commission_level_' + (commissionFee.currentPeriodPrice.level | lowercase)) | translate }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="medium">{{ 'general.api_fees_status' | translate }}</td>
                  <td class="align-right">{{ 'general.api_fees_status_active' | translate }}</td>
                </tr>
                <tr>
                  <td class="medium">{{ 'general.api_fees_period_start' | translate }}</td>
                  <td class="align-right">{{ commissionFee.currentPeriodPrice.period.start | moment: { withTime: true } }}</td>
                </tr>
                <tr>
                  <td class="medium">{{ 'general.api_fees_period_end' | translate }}</td>
                  <td class="align-right">{{ commissionFee.currentPeriodPrice.period.end ? (commissionFee.currentPeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
                </tr>
              </tbody>
            </table>
            <hr class="max-width no-margin">
          </div>
          <!-- MOBILE FUTURE FEES -->
          <div class="listing-block" *ngFor="let futurePeriodPrice of commissionFee.futurePeriodPrices; let feeIndex = index;">
            <table class="max-width bottom-spacer text-grey">
              <tbody>
                <tr>
                  <td colspan="2">
                    <div class="bottom-spacer-half">
                      <div class="no-margin heading-5 bold text-grey">
                        <span class="medium">{{ 'general.api_fees_price' | translate }}</span>
                        {{ futurePeriodPrice.feePrice !== null ? (futurePeriodPrice.feePrice | price) : (futurePeriodPrice.feePercent + '%') }}
                      </div>
                      <span class="text-grey body-3">{{ ( 'general.api_fees_commission_level_' + (futurePeriodPrice.level | lowercase)) | translate }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="medium">{{ 'general.api_fees_status' | translate }}</td>
                  <td class="align-right">{{ 'general.api_fees_status_future' | translate }}</td>
                </tr>
                <tr>
                  <td class="medium">{{ 'general.api_fees_period_start' | translate }}</td>
                  <td class="align-right">{{ futurePeriodPrice.period.start | moment: { withTime: true } }}</td>
                </tr>
                <tr>
                  <td class="medium">{{ 'general.api_fees_period_end' | translate }}</td>
                  <td class="align-right">{{ futurePeriodPrice.period.end ? (futurePeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
                </tr>
              </tbody>
            </table>
            <hr class="max-width no-margin">
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="flex flex-column" *ngIf="!utilService.isMobile">
    <app-info-message *ngIf="anyFeeMissing" [message]="'general.api_fees_commission_not_all_created'"></app-info-message>
    <ng-container *ngIf="!anyFeeMissing">
      <app-label-value *ngIf="paymentTerm" [label]="'general.api_fees_payment_term'" [tooltip]="'general.api_fees_payment_term_tooltip'"
                       [template]="paymentTermTemplate" [withMargin]="true"></app-label-value>
      <mat-slide-toggle [(ngModel)]="displayPastFees" [ngModelOptions]="{standalone: true}">
        {{ 'general.api_fees_display_past_fees' | translate }}
      </mat-slide-toggle>
      <div class="flex flex-column decreased-margin top-spacer" *ngFor="let commissionFee of commissionFees">
        <div class="flex space-between">
          <div class="bold">{{ ('general.api_fees_' + (commissionFee.type | lowercase)) | translate }}</div>
          <app-link *ngIf="canManageFees" [link]="'general.api_fees_commission_edit'" [icon]="'pencil'" (linkClicked)="openCommissionFeeModal(commissionFee)"></app-link>
        </div>
        <table class="report-table commission-fee-table">
          <thead>
            <tr>
              <th>{{ 'general.api_fees_status' | translate }}</th>
              <th>{{ 'general.api_fees_price' | translate }}</th>
              <th>{{ 'general.api_fees_period_start' | translate }}</th>
              <th>{{ 'general.api_fees_period_end' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- PAST FEES -->
            <ng-container *ngIf="displayPastFees">
              <ng-container *ngFor="let pastPeriodPrice of commissionFee.pastPeriodPrices">
                <tr class="text-muted">
                  <td>{{ 'general.api_fees_status_past' | translate }}</td>
                  <td class="fee-field">
                    {{ pastPeriodPrice.feePrice !== null ? (pastPeriodPrice.feePrice | price) : (pastPeriodPrice.feePercent + '%') }}
                    ({{ ( 'general.api_fees_commission_level_' + (pastPeriodPrice.level | lowercase)) | translate }})
                  </td>
                  <td>{{ pastPeriodPrice.period.start | moment: { withTime: true } }}</td>
                  <td>{{ pastPeriodPrice.period.end ? (pastPeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
                </tr>
              </ng-container>
            </ng-container>
            <!-- CURRENT FEES -->
            <tr class="medium" *ngIf="commissionFee.currentPeriodPrice">
              <td>{{ 'general.api_fees_status_active' | translate }}</td>
              <td class="fee-field">
                {{ commissionFee.currentPeriodPrice.feePrice !== null ? (commissionFee.currentPeriodPrice.feePrice | price) : (commissionFee.currentPeriodPrice.feePercent + '%') }}
                ({{ ( 'general.api_fees_commission_level_' + (commissionFee.currentPeriodPrice.level | lowercase)) | translate }})
              </td>
              <td>{{ commissionFee.currentPeriodPrice.period.start | moment: { withTime: true } }}</td>
              <td>{{ commissionFee.currentPeriodPrice.period.end ? (commissionFee.currentPeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
            </tr>
            <!-- FUTURE FEES -->
            <ng-container *ngFor="let futurePeriodPrice of commissionFee.futurePeriodPrices; let index = index">
              <tr *ngIf="index < 2" class="text-grey">
                <td>{{ 'general.api_fees_status_future' | translate }}</td>
                <td class="fee-field">
                  {{ futurePeriodPrice.feePrice !== null ? (futurePeriodPrice.feePrice | price) : (futurePeriodPrice.feePercent + '%') }}
                  ({{ ( 'general.api_fees_commission_level_' + (futurePeriodPrice.level | lowercase)) | translate }})
                </td>
                <td>{{ futurePeriodPrice.period.start | moment: { withTime: true } }}</td>
                <td>{{ futurePeriodPrice.period.end ? (futurePeriodPrice.period.end | moment: { withTime: true }) : '...' }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #paymentTermTemplate>
  <ng-container *ngIf="canManageFees">
    <mat-radio-group class="flex flex-wrap" [(ngModel)]="paymentTerm.type" (ngModelChange)="updatePaymentTerm()">
      <mat-radio-button [value]="PaymentTermType.Netting">{{ 'general.api_fees_payment_term_netting' | translate }}</mat-radio-button>
      <mat-radio-button [value]="PaymentTermType.Transfer">{{ 'general.api_fees_payment_term_transfer' | translate }}</mat-radio-button>
    </mat-radio-group>
    <app-numeric-input *ngIf="paymentTerm.type === PaymentTermType.Transfer" [label]="'general.api_fees_transfer_number_of_days'"
                       [(value)]="paymentTerm.numberOfDays" [max]="90" [min]="1" [required]="true" (isValueValid)="updateNumberOfDays($event)"></app-numeric-input>
  </ng-container>
  <div *ngIf="!canManageFees">
    {{ ('general.api_fees_payment_term_' + (paymentTerm.type | lowercase)) | translate }}
    <ng-container *ngIf="paymentTerm.type === PaymentTermType.Transfer"> ({{ paymentTerm.numberOfDays }}&nbsp;{{ 'general.api_general_days' | translate }})</ng-container>
  </div>
</ng-template>
<app-loader [loading]="isLoading" [overlay]="true"></app-loader>
